import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="context-filter"
export default class extends Controller {
  static targets = ["dropdown", "toggle", "buttonText"]

  toggleDropdown(event) {
    event.preventDefault()
    this.dropdownTarget.classList.toggle("hidden")
  }

  applyFilter(event) {
    // Collect all checked tag IDs
    const checkboxes = this.element.querySelectorAll('input[type="checkbox"]:checked')
    const tagIds = Array.from(checkboxes).map(cb => cb.value)

    // Build query params
    const params = new URLSearchParams(window.location.search)

    // Remove existing context_tag_ids params
    params.delete('context_tag_ids[]')

    // Add new ones
    if (tagIds.length > 0) {
      tagIds.forEach(id => {
        params.append('context_tag_ids[]', id)
      })
    }

    // Update button text
    if (this.hasButtonTextTarget) {
      if (tagIds.length > 0) {
        this.buttonTextTarget.textContent = `${tagIds.length} selected`
      } else {
        this.buttonTextTarget.textContent = 'Filter by context'
      }
    }

    // Reload page with new filters
    const newUrl = `${window.location.pathname}?${params.toString()}`
    window.location.href = newUrl
  }

  clearFilters(event) {
    event.preventDefault()

    // Uncheck all checkboxes
    const checkboxes = this.element.querySelectorAll('input[type="checkbox"]')
    checkboxes.forEach(cb => cb.checked = false)

    // Remove context_tag_ids from URL and reload
    const params = new URLSearchParams(window.location.search)
    params.delete('context_tag_ids[]')

    const newUrl = params.toString() ? `${window.location.pathname}?${params.toString()}` : window.location.pathname
    window.location.href = newUrl
  }
}
